const toggleCloseSearchBtn = () => {
  const input = document.querySelector('.header-search__input');
  const closeButton = document.querySelector('.predictive-search-close');
  const searchContent = document.querySelector('.predictive-search__content');
  input?.addEventListener('input', function () {
    if (input.value && closeButton) {
      closeButton.style.display = 'block';
      searchContent.setAttribute('open', '');
      closeButton.addEventListener('click', (e) => {
        input.value = '';
        searchContent.innerHTML = '';
        searchContent.removeAttribute('open');
        setTimeout(() => {
          closeButton.style.display = 'none';
        }, 300);
      });
    } else if (!input.value && closeButton) {
      closeButton.style.display = 'none';
      searchContent.removeAttribute('open');
    }
  });
};

const observePredictiveSearch = () => {
  const predictiveSearchElement = document.querySelector('.predictive-search');

  if (!predictiveSearchElement) {
    return;
  }

  const updateBodyClass = () => {
    const resultsElement = predictiveSearchElement.querySelector('.predictive-search__results');
    if (resultsElement) {
      document.body.classList.add('body-overlay');
    } else {
      document.body.classList.remove('body-overlay');
    }
  };

  const observerCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        updateBodyClass();
      }
    }
  };

  const observer = new MutationObserver(observerCallback);
  observer.observe(predictiveSearchElement, { childList: true, subtree: true });

  updateBodyClass();
};

const handleElementPosition = (customSearch, sidebarSearch, secondaryNav) => {
  if (window.innerWidth < 1000) {
    sidebarSearch.appendChild(customSearch);
  } else {
    secondaryNav.parentNode.insertBefore(customSearch, secondaryNav);
  }
};

const moveSearchToSidebar = () => {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  const callback = function (mutationsList, observer) {
    const customSearch = document.querySelector('.header-search--custom');
    const sidebarSearch = document.querySelector('.header-sidebar__search');
    const secondaryNav = document.querySelector('.header__secondary-nav');

    if (customSearch && sidebarSearch && secondaryNav) {
      handleElementPosition(customSearch, sidebarSearch, secondaryNav);
      observer.disconnect(); // Stop observing once elements are found and handled
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

const observeHeaderSidebar = () => {
  const headerSidebar = document.querySelector('header-sidebar');
  if (!headerSidebar) return;

  const updateBodyClass = () => {
    if (headerSidebar.hasAttribute('open')) {
      const headerSidebarFooter = headerSidebar.querySelector('.header-sidebar__footer');
      if (headerSidebarFooter) document.documentElement.style.setProperty('--header-sidebar-footer-height', `${headerSidebarFooter.clientHeight.toFixed(2)}px`);
      document.body.classList.add('header-sidebar-opened');
    } else {
      document.body.classList.remove('header-sidebar-opened');
    }
  };

  const observerCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        updateBodyClass();
      }
    }
  };

  const observer = new MutationObserver(observerCallback);
  observer.observe(headerSidebar, { attributes: true });

  // Initial check in case the element is already open
  updateBodyClass();
};

document.addEventListener('DOMContentLoaded', () => {
  const customSearch = document.querySelector('.header-search--custom');
  const sidebarSearch = document.querySelector('.header-sidebar__search');
  const secondaryNav = document.querySelector('.header__secondary-nav');

  if (customSearch && sidebarSearch && secondaryNav) {
    handleElementPosition(customSearch, sidebarSearch, secondaryNav);
  }

  observeHeaderSidebar();
  moveSearchToSidebar();
  observePredictiveSearch();
  toggleCloseSearchBtn();
});

window.addEventListener('resize', () => {
  const customSearch = document.querySelector('.header-search--custom');
  const sidebarSearch = document.querySelector('.header-sidebar__search');
  const secondaryNav = document.querySelector('.header__secondary-nav');

  if (customSearch && sidebarSearch && secondaryNav) {
    handleElementPosition(customSearch, sidebarSearch, secondaryNav);
  }
});
